import { render, staticRenderFns } from "./box3.vue?vue&type=template&id=932113e4&scoped=true&"
import script from "./box3.vue?vue&type=script&lang=ts&"
export * from "./box3.vue?vue&type=script&lang=ts&"
import style0 from "./box3.vue?vue&type=style&index=0&id=932113e4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "932113e4",
  null
  
)

export default component.exports